import { Icons } from "assets/icons";
import NoDataFound from "components/common/NoDataFound";
import { StatusBadge } from "components/common/StatusBadge";
import DataTable from "components/common/table/DataTable";
import TableShimmer from "components/common/TableShimmer";
import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getVehicleDetails } from "store/slices/customersSlice";
import { formatUTCDate } from "utils/utils";

const Vehicles = ({ id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { loading2, vehicleDetails } = useSelector((state) => state.Customers);
  const { noVehicles } = Icons || {};

  useEffect(() => {
    dispatch(getVehicleDetails(id));
  }, []);

  const columns = useMemo(
    () => [
      {
        header: "Color",
        key: "colorId",
        render: (value) => value?.name?.en || "-",
      },
      {
        header: "Brand",
        key: "makeId",
        render: (value) => value?.name?.en || "-",
      },
      {
        header: "Model",
        key: "modelId",
        render: (value) => value?.name?.en || "-",
      },
      {
        header: "Year",
        key: "year",
      },
      {
        header: "Plate Number",
        key: "licencePlateNumber",
        render: (value) => <div className="ltr_text">{value || "-"}</div>,
      },
      {
        header: "Created Date",
        key: "createdAt",
        render: (value) => (
          <div className="ltr_text">{formatUTCDate(value)}</div>
        ),
      },
      {
        header: "Status",
        key: "status",
        render: (value) => <StatusBadge status={value} t={t} />,
      },
    ],
    [t]
  );

  return (
    <div>
      {loading2 && <TableShimmer rows={12} columns={8} />}

      {!loading2 && vehicleDetails?.length === 0 && (
        <NoDataFound title={t("No vehicles found")} icon={noVehicles} />
      )}

      {!loading2 && vehicleDetails?.length > 0 && (
        <>
          <DataTable
            columns={columns}
            data={vehicleDetails}
            emptyMessage={t("No vehicles found")}
            t={t}
          />
        </>
      )}
    </div>
  );
};

export default Vehicles;
